import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Camera, ImageOff, Loader2, UserPlus } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewClientBadge = ({ booking, small = false, iconOnly = false }) => {
  if (!booking?.is_new_client) return null;
  if (iconOnly) {
    return (
      <span title="Nuovo cliente" aria-label="Nuovo cliente" data-testid={`new-client-badge-${booking.id}`}
        className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full bg-emerald-500 text-white flex-shrink-0">
        <UserPlus className="h-2.5 w-2.5" />
      </span>
    );
  }
  return (
    <span data-testid={`new-client-badge-${booking.id}`}
      className={`inline-flex items-center gap-1 rounded-full bg-emerald-500/20 text-emerald-400 border border-emerald-500/40 font-semibold whitespace-nowrap flex-shrink-0 ${small ? 'text-[9px] px-1.5 py-0' : 'text-[11px] px-2 py-0.5'}`}>
      <UserPlus className={small ? 'h-2.5 w-2.5' : 'h-3 w-3'} /> Nuovo cliente
    </span>
  );
};

const AuthPhoto = ({ photoId, headers, onOpen, testId }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let url;
    axios.get(`${API}/reference-photos/${photoId}`, { headers, responseType: 'blob' })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setFailed(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [photoId]); // eslint-disable-line react-hooks/exhaustive-deps

  const box = 'w-20 h-20 rounded-lg border border-border flex items-center justify-center bg-secondary overflow-hidden';
  if (failed) return <div className={box} data-testid={testId}><ImageOff className="h-5 w-5 text-muted-foreground" /></div>;
  if (!src) return <div className={box} data-testid={testId}><Loader2 className="h-4 w-4 animate-spin" /></div>;
  return (
    <button type="button" className={`${box} hover:ring-2 hover:ring-accent transition-shadow`} onClick={() => onOpen(src)} data-testid={testId}>
      <img src={src} alt="Foto di riferimento" className="w-full h-full object-cover" />
    </button>
  );
};

export const ReferencePhotos = ({ booking, headers, title = 'Foto di riferimento' }) => {
  const [open, setOpen] = useState(null);
  if (!booking?.reference_photos?.length) return null;
  return (
    <div className="mt-2" data-testid={`reference-photos-${booking.id}`}>
      <p className="text-xs font-semibold text-accent flex items-center gap-1.5 mb-1.5"><Camera className="h-3.5 w-3.5" /> {title}</p>
      <div className="flex flex-wrap gap-2">
        {booking.reference_photos.map((pid) => (
          <AuthPhoto key={pid} photoId={pid} headers={headers} onOpen={setOpen} testId={`reference-photo-${pid}`} />
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => { if (!o) setOpen(null); }}>
        <DialogContent className="max-w-2xl">
          <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
          {open && <img src={open} alt="Foto di riferimento ingrandita" className="w-full max-h-[75vh] object-contain rounded-lg" data-testid="reference-photo-full" />}
        </DialogContent>
      </Dialog>
    </div>
  );
};
